import { useQuery } from '@tanstack/react-query'
import { getDesk } from './api'

/** The title's Pit Lane brand pages switch, read from the desk query the layout already caches
 *  (the settings route is editor-only; the desk is open to writers). Off until it loads. */
export function useSectionBrandsOn(slug: string | undefined): boolean {
  const q = useQuery({ queryKey: ['editorial-desk', slug], queryFn: () => getDesk(slug as string), enabled: !!slug, staleTime: 30_000, retry: false })
  return q.data?.section_brands_on === true
}
